<div class="geo-fence-container">
  <div class="zone-lists-container">
    <div class="zone-list available-zones">
      <h3>Available Zones</h3>
      <ul *ngIf="availableZoneDetails?.length">
        <li *ngFor="let zone of availableZoneDetails" class="list-display">
          <span>{{ zone.name }}</span>
          <mat-icon (click)="addZone(zone)" class="add-icon">add</mat-icon>
        </li>
      </ul>
      <h2 *ngIf="!availableZoneDetails?.length" class="no-data">No available zones</h2>
    </div>
    <div class="zone-list assigned-zones">
      <div class="zone-lists-button-container">
        <h3>Assigned Zones</h3>
        <div class="tag-action" *ngIf="tagFlag || untagFlag">
          <button mat-raised-button class="tag-button" type="submit" (click)="tagEntityToZone()">
            {{ tagFlag ? 'Tag' : 'Untag'}}
          </button>
        </div>
      </div>
      <ul *ngIf="assignedZones?.length">
        <li *ngFor="let zone of assignedZones" class="list-display">
          <span>{{ zone?.name }}</span>
          <mat-icon (click)="removeZone(zone)" class="remove-icon">remove</mat-icon>
        </li>
      </ul>
      <h1 *ngIf="!assignedZones?.length" class="no-data">No assigned zones</h1>
    </div>
  </div>
  <div *ngIf="showForm" class="panel-title">
    Add Zone
  </div>
  <div *ngIf="showForm" class="left-side-tab position-relative">
    <mat-tab-group [formGroup]="zoneForm" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)"
      class="-mat-tab-list-d-flex">
      <div class="d-flex w-100 make-responsive">
        <mat-tab label="{{ 'zone' | translate }} Details">
          <ng-template mat-tab-label>
            <div class="mat-tab-label-content">{{ 'zone' | translate }} Details</div>
            <mat-icon class="material-icons red-color"
              *ngIf="formSubmitted && (zoneForm?.get('name')?.invalid || zoneForm?.get('selectZone')?.invalid || zoneForm?.get('level')?.invalid)">
              highlight_off
            </mat-icon>
          </ng-template>
          <div class="modal-form d-flex">
            <mat-form-field class="mb-20">
              <mat-label>Select {{ 'zone' | translate }}</mat-label>
              <mat-select formControlName="selectZone">
                <mat-option *ngFor="let option of restrictedEntryZones" [value]="option">{{ option }}
                </mat-option>
              </mat-select>
              <ng-container *ngIf="formSubmitted && zoneForm?.get('selectZone')?.errors">
                <mat-error *ngIf="zoneForm?.get('selectZone')?.errors?.['required']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ 'zone' | translate }} order is
                  required
                </mat-error>
              </ng-container>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ MESSAGES?.ZONE_FORM_NAME_LABEL }}</mat-label>
              <input matInput formControlName="name">
              <ng-container *ngIf="formSubmitted && zoneForm?.get('name')?.errors">
                <mat-error *ngIf="zoneForm?.get('name')?.errors?.['required']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_NAME_REQUIRED }}
                </mat-error>
                <mat-error *ngIf="zoneForm?.get('name')?.errors?.['pattern']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_NAME_PATTERN }}
                </mat-error>
              </ng-container>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ MESSAGES?.ZONE_FORM_LEVEL_LABEL }}</mat-label>
              <input matInput formControlName="level" type="number">
              <ng-container *ngIf="formSubmitted && zoneForm?.get('level')?.errors">
                <mat-error *ngIf="zoneForm?.get('level')?.errors?.['required']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_LEVEL_REQUIRED }}
                </mat-error>
              </ng-container>
            </mat-form-field>
            <div class="modal-form d-flex" formGroupName="geoFence">
              <div formGroupName="properties" class="-hex-code-input-field">
              <mat-form-field>
                <mat-label>{{ MESSAGES?.ZONE_FORM_LABEL_COLOR_LABEL }}</mat-label>
                <span class="d-flex align-items-center hex-style">
                  <input matInput formControlName="labelColor" type="color" class="color">
                  <span>HEX CODE:</span> <a id="hex_code">{{zoneForm?.get('geoFence.properties.labelColor')?.value}}</a></span>
                <ng-container *ngIf="formSubmitted && zoneForm?.get('geoFence.properties.labelColor')?.errors">
                  <mat-error *ngIf="zoneForm?.get('geoFence.properties.labelColor')?.errors?.['required']">
                    <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_LABEL_COLOR_REQUIRED }}
                  </mat-error>
                </ng-container>
              </mat-form-field>
            </div>
          </div>
          </div>
        </mat-tab>

        <mat-tab label="Attributes">
          <ng-template mat-tab-label>
            <div class="mat-tab-label-content">Attributes</div>
            <mat-icon class="material-icons red-color"
              *ngIf="formSubmitted && (zoneForm?.get('attribute.riskType')?.invalid)">
              highlight_off
            </mat-icon>
          </ng-template>
          <div class=" modal-form gridgap-unset d-flex make-responsive mb-20" formGroupName="attribute">
            <mat-form-field>
              <mat-label>{{ MESSAGES?.ZONE_FORM_RISK_TYPE_LABEL }}</mat-label>
              <mat-select formControlName="riskType">
                <mat-option *ngFor="let option of riskList" [value]="option">{{ option }}</mat-option>
              </mat-select>
              <ng-container *ngIf="formSubmitted && zoneForm?.get('attribute.riskType')?.errors">
                <mat-error *ngIf="zoneForm?.get('attribute.riskType')?.errors?.['required']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_RISK_TYPE_REQUIRED }}
                </mat-error>
              </ng-container>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ MESSAGES?.ZONE_FORM_ALTITUDE_LABEL }}</mat-label>
              <input matInput formControlName="altitude" type="number">
              <ng-container *ngIf="formSubmitted && zoneForm?.get('attribute.altitude')?.errors">
                <mat-error *ngIf="zoneForm?.get('attribute.altitude')?.errors?.['required']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_ALTITUDE_REQUIRED }}
                </mat-error>
              </ng-container>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ MESSAGES?.ZONE_FORM_MAX_PRESSURE_LABEL }}</mat-label>
              <input matInput formControlName="maxPressure" type="number">
              <ng-container *ngIf="formSubmitted && zoneForm?.get('attribute.maxPressure')?.errors">
                <mat-error *ngIf="zoneForm?.get('attribute.maxPressure')?.errors?.['required']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_MAX_PRESSURE_REQUIRED }}
                </mat-error>
              </ng-container>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ MESSAGES?.ZONE_FORM_MIN_PRESSURE_LABEL }}</mat-label>
              <input matInput formControlName="minPressure" type="number">
              <ng-container *ngIf="formSubmitted && zoneForm?.get('attribute.minPressure')?.errors">
                <mat-error *ngIf="zoneForm?.get('attribute.minPressure')?.errors?.['required']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_MIN_PRESSURE_REQUIRED }}
                </mat-error>
              </ng-container>
            </mat-form-field>
          </div>
          <div formGroupName="geoFence">
            <div class="modal-form gridgap-unset d-flex make-responsive mb-20" formGroupName="properties">
              <mat-form-field>
                <mat-label>{{ MESSAGES?.ZONE_FORM_STROKE_OPACITY_LABEL }}</mat-label>
                <input matInput formControlName="strokeOpacity" type="number">
                <ng-container *ngIf="formSubmitted && zoneForm?.get('geoFence.properties.strokeOpacity')?.errors">
                  <mat-error *ngIf="zoneForm?.get('geoFence.properties.strokeOpacity')?.errors?.['required']">
                    <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_STROKE_OPACITY_REQUIRED }}
                  </mat-error>
                </ng-container>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ MESSAGES?.ZONE_FORM_STROKE_WEIGHT_LABEL }}</mat-label>
                <input matInput formControlName="strokeWeight" type="number">
                <ng-container *ngIf="formSubmitted && zoneForm?.get('geoFence.properties.strokeWeight')?.errors">
                  <mat-error *ngIf="zoneForm?.get('geoFence.properties.strokeWeight')?.errors?.['required']">
                    <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_STROKE_WEIGHT_REQUIRED }}
                  </mat-error>
                </ng-container>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ MESSAGES?.ZONE_FORM_FILL_OPACITY_LABEL }}</mat-label>
                <input matInput formControlName="fillOpacity" type="number">
                <ng-container *ngIf="formSubmitted && zoneForm?.get('geoFence.properties.fillOpacity')?.errors">
                  <mat-error *ngIf="zoneForm?.get('geoFence.properties.fillOpacity')?.errors?.['required']">
                    <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_FILL_OPACITY_REQUIRED }}
                  </mat-error>
                </ng-container>
              </mat-form-field>
              <mat-form-field class="-hex-code-input-field">
                <mat-label>{{ MESSAGES?.ZONE_FORM_FILL_COLOR_LABEL }}</mat-label>
                <span class="d-flex align-items-center hex-style">
                  <input matInput formControlName="fillColor" type="color" class="color">
                  <span>HEX CODE:</span> <a id="hex_code">{{ zoneForm?.get('geoFence.properties.fillColor')?.value }}</a></span>
                <ng-container *ngIf="formSubmitted && zoneForm?.get('geoFence.properties.fillColor')?.errors">
                  <mat-error *ngIf="zoneForm?.get('geoFence.properties.fillColor')?.errors?.['required']">
                    <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_FILL_COLOR_REQUIRED }}
                  </mat-error>
                </ng-container>
              </mat-form-field>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Zone Restrictions">
          <ng-template mat-tab-label>
            <div class="mat-tab-label-content">Zone Restrictions</div>
            <mat-icon class="material-icons red-color"
              *ngIf="formSubmitted && zoneForm?.get('zoneRestrictions.selectHierarchy')?.invalid">
              highlight_off
            </mat-icon>
          </ng-template>
          <div class="modal-form d-flex mb-20" formGroupName="zoneRestrictions">
            <mat-form-field>
              <mat-label>{{ MESSAGES?.ZONE_FORM_SELECT_HIERARCHY_LABEL }}</mat-label>
              <mat-select formControlName="selectHierarchy">
                <mat-option *ngFor="let item of hierarchyList" [value]="item?.name" (onSelectionChange)="reaCheckParentZone($event)">{{
                  item?.name }}</mat-option>
              </mat-select>
              <ng-container *ngIf="formSubmitted && zoneForm?.get('zoneRestrictions.selectHierarchy')?.errors">
                <mat-error *ngIf="zoneForm?.get('zoneRestrictions.selectHierarchy')?.errors?.['required']">
                  <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_SELECT_HIERARCHY_REQUIRED }}
                </mat-error>
              </ng-container>
            </mat-form-field>
          </div>
          <div class="make-responsive" formGroupName="restrictedAccess">
            <div class="modal-form d-flex">
              <mat-form-field>
                <mat-label>{{ MESSAGES?.ZONE_FORM_START_TIME_LABEL }}</mat-label>
                <input type="time" matInput name="start" formControlName="start" (change)="timeValidation()">
              </mat-form-field>
            </div>
            <div class="modal-form d-flex">
              <mat-form-field>
                <mat-label>{{ MESSAGES?.ZONE_FORM_END_TIME_LABEL }}</mat-label>
                <input type="time" matInput name="end" formControlName="end" (change)="timeValidation()">
              </mat-form-field>
            </div>
            <div class="modal-form d-flex time-group">
              <mat-form-field>
                <mat-label>{{ MESSAGES?.ZONE_FORM_TIME_ZONE_LABEL }}</mat-label>
                <mat-select formControlName="timeZone">
                  <mat-option *ngFor="let item of timeZoneList" [value]="item?.value">
                    {{item?.name}}
                  </mat-option>
                  <div *ngIf="formSubmitted && zoneForm?.get('restrictedAccess.timeZone')?.errors">
                    <mat-error *ngIf="zoneForm?.get('restrictedAccess.timeZone')?.errors?.['required']">
                      <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.ZONE_FORM_NAME_LABEL }}
                    </mat-error>
                  </div>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-tab>
      </div>
    </mat-tab-group>
    <div class="red-color" style="text-align: center;">{{errorMessage}}</div>
    <div class="form-actions m-0 pt-4">
      <button mat-raised-button type="submit" (click)="onSubmit()">Submit</button>
    </div>
  </div>
</div>